import { render, staticRenderFns } from "./videoRecordingStatisticsList.vue?vue&type=template&id=1b4ae250"
import script from "./videoRecordingStatisticsList.vue?vue&type=script&lang=js"
export * from "./videoRecordingStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./videoRecordingStatisticsList.vue?vue&type=style&index=0&id=1b4ae250&prod&lang=less"
import style1 from "./videoRecordingStatisticsList.vue?vue&type=style&index=1&id=1b4ae250&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports